// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Overlay ── */
.ttd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1200;
}

/* ── Drawer panel ── */
.ttd-drawer {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 80vw;
  max-width: 95vw;
  background: #fff;
  z-index: 1201;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.18);
  animation: ttdSlideIn 0.22s ease;
}

@keyframes ttdSlideIn {
  from { transform: translateX(100%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

/* ── Header ── */
.ttd-header {
  padding: 20px 24px 0;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.ttd-header-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 4px;
}

.ttd-title-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ttd-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #111;
  margin: 0;
}

.ttd-subtitle {
  font-size: 0.813rem;
  color: #666;
  margin: 2px 0 12px;
}

.ttd-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: #444;
  display: flex;
  align-items: center;
}

.ttd-close-btn:hover { color: #000; }

/* ── Area tabs ── */
.ttd-tabs {
  display: flex;
  gap: 0;
  flex-wrap: wrap;
}

.ttd-tab {
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  border: none;
  background: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
}

.ttd-tab:hover { color: #111; }

.ttd-tab.active {
  color: #0860E6;
  border-bottom: 2px solid #0860E6;
  font-weight: 600;
}

/* ── Body ── */
.ttd-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
}

.ttd-body::-webkit-scrollbar { width: 4px; }
.ttd-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }

/* ── Loader / Empty ── */
.ttd-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
}

.ttd-empty {
  text-align: center;
  color: #6b7280;
  font-size: 0.875rem;
  padding: 60px 0;
}

/* ── Tables grid ── */
.ttd-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
}

.ttd-table-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 12px 8px;
  border-radius: 8px;
  border: 1.5px solid #e5e7eb;
  background: #f8f9fb;
  cursor: pointer;
  transition: all 0.15s;
  min-height: 80px;
}

.ttd-table-card:hover {
  border-color: #93b4f5;
  background: #f0f5ff;
}

.ttd-table-card.selected {
  border-color: #0860E6;
  background: #eaf1fd;
}

.ttd-table-name {
  font-size: 0.813rem;
  font-weight: 600;
  color: #111;
  text-align: center;
}

.ttd-table-seats {
  font-size: 0.75rem;
  color: #6b7280;
}

/* ── Footer ── */
.ttd-footer {
  padding: 14px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: #fff;
}

.ttd-cancel-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 0.875rem;
  font-weight: 500;
  color: #444;
  cursor: pointer;
}

.ttd-cancel-btn:hover { background: #f5f5f5; }

.ttd-transfer-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border: none;
  border-radius: 6px;
  background: #0860E6;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  min-width: 140px;
  justify-content: center;
}

.ttd-transfer-btn:hover:not(:disabled) { background: #0752c8; }

.ttd-transfer-btn:disabled {
  background: #93b4f5;
  cursor: not-allowed;
}

/* ═══ DARK THEME — TransferTableModal ═══ */
.dark .ttd-drawer {
  background: #1e293b;
  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.5);
}
.dark .ttd-header { border-bottom-color: #334155; }
.dark .ttd-title  { color: #f1f5f9; }
.dark .ttd-subtitle { color: #94a3b8; }
.dark .ttd-close-btn { color: #64748b; }
.dark .ttd-close-btn:hover { color: #e2e8f0; }

.dark .ttd-tab { color: #64748b; }
.dark .ttd-tab:hover { color: #e2e8f0; }
.dark .ttd-tab.active { color: #0860e6; border-bottom-color: #0860e6; }

.dark .ttd-empty { color: #64748b; }

.dark .ttd-table-card {
  background: #0f172a;
  border-color: #334155;
}
.dark .ttd-table-card:hover { border-color: #3b82f6; background: #1e293b; }
.dark .ttd-table-card.selected { border-color: #0860e6; background: rgba(8,96,230,0.1); }
.dark .ttd-table-name  { color: #e2e8f0; }
.dark .ttd-table-seats { color: #64748b; }

.dark .ttd-footer {
  background: #1e293b;
  border-top-color: #334155;
}
.dark .ttd-cancel-btn {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .ttd-cancel-btn:hover { background: #334155; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/TransferTableModal/TransferTableModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB,WAAW,EAAE;;AAEpC,oBAAoB;AACpB;EACE,aAAa;EACb,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,iBAAiB,WAAW,EAAE;;AAE9B;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,mBAAmB,EAAE,kBAAkB,EAAE;;AAE9E,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,yCAAyC,mBAAmB,EAAE;;AAE9D;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;AACA,oBAAoB,4BAA4B,EAAE;AAClD,oBAAoB,cAAc,EAAE;AACpC,sBAAsB,cAAc,EAAE;AACtC,uBAAuB,cAAc,EAAE;AACvC,6BAA6B,cAAc,EAAE;;AAE7C,iBAAiB,cAAc,EAAE;AACjC,uBAAuB,cAAc,EAAE;AACvC,wBAAwB,cAAc,EAAE,4BAA4B,EAAE;;AAEtE,mBAAmB,cAAc,EAAE;;AAEnC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE;AAC1E,iCAAiC,qBAAqB,EAAE,8BAA8B,EAAE;AACxF,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;;AAEzC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,8BAA8B,mBAAmB,EAAE","sourcesContent":["/* ── Overlay ── */\n.ttd-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1200;\n}\n\n/* ── Drawer panel ── */\n.ttd-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 80vw;\n  max-width: 95vw;\n  background: #fff;\n  z-index: 1201;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.18);\n  animation: ttdSlideIn 0.22s ease;\n}\n\n@keyframes ttdSlideIn {\n  from { transform: translateX(100%); opacity: 0; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n\n/* ── Header ── */\n.ttd-header {\n  padding: 20px 24px 0;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.ttd-header-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.ttd-title-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ttd-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #111;\n  margin: 0;\n}\n\n.ttd-subtitle {\n  font-size: 0.813rem;\n  color: #666;\n  margin: 2px 0 12px;\n}\n\n.ttd-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px;\n  color: #444;\n  display: flex;\n  align-items: center;\n}\n\n.ttd-close-btn:hover { color: #000; }\n\n/* ── Area tabs ── */\n.ttd-tabs {\n  display: flex;\n  gap: 0;\n  flex-wrap: wrap;\n}\n\n.ttd-tab {\n  padding: 8px 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #555;\n  cursor: pointer;\n  border: none;\n  background: none;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n}\n\n.ttd-tab:hover { color: #111; }\n\n.ttd-tab.active {\n  color: #0860E6;\n  border-bottom: 2px solid #0860E6;\n  font-weight: 600;\n}\n\n/* ── Body ── */\n.ttd-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px;\n}\n\n.ttd-body::-webkit-scrollbar { width: 4px; }\n.ttd-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }\n\n/* ── Loader / Empty ── */\n.ttd-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 160px;\n}\n\n.ttd-empty {\n  text-align: center;\n  color: #6b7280;\n  font-size: 0.875rem;\n  padding: 60px 0;\n}\n\n/* ── Tables grid ── */\n.ttd-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: 10px;\n}\n\n.ttd-table-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 12px 8px;\n  border-radius: 8px;\n  border: 1.5px solid #e5e7eb;\n  background: #f8f9fb;\n  cursor: pointer;\n  transition: all 0.15s;\n  min-height: 80px;\n}\n\n.ttd-table-card:hover {\n  border-color: #93b4f5;\n  background: #f0f5ff;\n}\n\n.ttd-table-card.selected {\n  border-color: #0860E6;\n  background: #eaf1fd;\n}\n\n.ttd-table-name {\n  font-size: 0.813rem;\n  font-weight: 600;\n  color: #111;\n  text-align: center;\n}\n\n.ttd-table-seats {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n/* ── Footer ── */\n.ttd-footer {\n  padding: 14px 24px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.ttd-cancel-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 18px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #444;\n  cursor: pointer;\n}\n\n.ttd-cancel-btn:hover { background: #f5f5f5; }\n\n.ttd-transfer-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 20px;\n  border: none;\n  border-radius: 6px;\n  background: #0860E6;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  min-width: 140px;\n  justify-content: center;\n}\n\n.ttd-transfer-btn:hover:not(:disabled) { background: #0752c8; }\n\n.ttd-transfer-btn:disabled {\n  background: #93b4f5;\n  cursor: not-allowed;\n}\n\n/* ═══ DARK THEME — TransferTableModal ═══ */\n.dark .ttd-drawer {\n  background: #1e293b;\n  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.5);\n}\n.dark .ttd-header { border-bottom-color: #334155; }\n.dark .ttd-title  { color: #f1f5f9; }\n.dark .ttd-subtitle { color: #94a3b8; }\n.dark .ttd-close-btn { color: #64748b; }\n.dark .ttd-close-btn:hover { color: #e2e8f0; }\n\n.dark .ttd-tab { color: #64748b; }\n.dark .ttd-tab:hover { color: #e2e8f0; }\n.dark .ttd-tab.active { color: #0860e6; border-bottom-color: #0860e6; }\n\n.dark .ttd-empty { color: #64748b; }\n\n.dark .ttd-table-card {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .ttd-table-card:hover { border-color: #3b82f6; background: #1e293b; }\n.dark .ttd-table-card.selected { border-color: #0860e6; background: rgba(8,96,230,0.1); }\n.dark .ttd-table-name  { color: #e2e8f0; }\n.dark .ttd-table-seats { color: #64748b; }\n\n.dark .ttd-footer {\n  background: #1e293b;\n  border-top-color: #334155;\n}\n.dark .ttd-cancel-btn {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .ttd-cancel-btn:hover { background: #334155; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
